<template>
  <div>
    <!-- 3แยก -->
    <div
      v-if="check < 4"
      class="video-grid"
    >
      <!-- Adding py-2 for vertical padding and px-1 for horizontal padding between columns -->
      <b-row
        class="mx-1"
        style="padding-left: 20px;"
      >
        <b-col
          v-for="(item, index) in count.slice(0, 3)"
          :key="index"
          cols="4"
          class="px-1"
        >
          <b-link
            v-b-modal="'Live'"
            @click="$refs.RTSP.streamLive(count[index].RTSP_URL)"
          >
            <video
              :id="'count' + index"
              muted
              autoplay
              playsinline
              style="height: 140px; width: 70%; object-fit: cover; object-position: top center; margin: 0 auto; display: block;"
            />
          </b-link>
          <div
            class="text-style"
            style="text-align: center;"
          >
            <span style="display: block; margin: 0; text-align: center; font-size: 12px;">{{ item.Phase }}<br></span>
            <span style="display: block; margin: 0; text-align: center; font-size: 12px; margin-top: -3px;">{{ item.Camera_Desc }}</span>
          </div>
        </b-col>
      </b-row>
      <b-row
        class="mx-1"
        style="padding-left: 20px;"
      >
        <b-col
          v-for="(item, index) in stopline.slice(0, 3)"
          :key="index + 3"
          cols="4"
          class="px-1"
        >
          <b-link
            v-b-modal="'Live'"
            @click="$refs.RTSP.streamLive(stopline[index].RTSP_URL)"
          >
            <video
              :id="'stopline' + index"
              muted
              autoplay
              playsinline
              style="height: 140px; width: 70%; object-fit: cover; object-position: top center; margin: 0 auto; display: block;"
            />
            <!-- object-position: top center; -->
            <!-- object-fit: contain; หรือ cover; -->
          </b-link>
          <div
            class="text-style"
            style="text-align: center;"
          >
            <span style="display: block; margin: 0; text-align: center; font-size: 12px;">{{ item.Phase }}<br></span>
            <span style="display: block; margin: 0; text-align: center; font-size: 12px; margin-top: -6px;">{{ item.Camera_Desc }}</span>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- 4แยก 4กล้อง-->
    <div
      v-else-if="check === 4 && countPhase === 4"
    >
      <b-row
        class="mx-1"
        style="padding-left: 10px; padding-top: 55px;"
      >
        <b-col
          v-for="(item, index) in count.slice(0,4)"
          :key="index"
          cols="3"
          class="px-1"
          style="margin-bottom: 10px;"
        >
          <b-link
            v-b-modal="'Live'"
            @click="$refs.RTSP.streamLive(count[index].RTSP_URL)"
          >
            <video
              :id="'count' + (index)"
              muted
              autoplay
              playsinline
              style="height: 220px; width: 100%; object-fit: cover; margin: 0 auto; display: block;"
            />
          </b-link>
          <div
            class="text-style"
            style="text-align: center;"
          >
            <span style="display: block; margin: 0; text-align: center; font-size: 12px;">{{ item.Phase }}<br></span>
            <span style="display: block; margin: 0; text-align: center; font-size: 12px;">จุดติดตั้ง: {{ item.Camera_Desc }}</span>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- 4แยก -->
    <div
      v-if="check === 4 && countPhase > 4"
      style="max-height: 430px;"
    >
      <!-- Group 1: First 4 from count -->
      <b-row
        class="mx-1"
        style="padding-left: 20px;"
      >
        <b-col
          v-for="(item, index) in count.slice(0, 4)"
          :key="'count' + index"
          lg="3"
          md="6"
          sm="12"
        >
          <b-link
            v-b-modal="'Live'"
            @click="$refs.RTSP.streamLive(count[index].RTSP_URL)"
          >
            <div>
              <video
                :id="'count' + index"
                muted
                autoplay
                playsinline
                style="height: 140px; width: 70%; object-fit: cover; object-position: top center; margin: 0 auto; display: block;"
              />
            </div>
          </b-link>
          <span style="display: block; margin: 0; text-align: center; font-size: 11px;">{{ item.Phase }}<br></span>
          <span style="display: block; margin: 0; text-align: center; font-size: 12px; margin-top: -15px;">{{ item.Camera_Desc }}</span>
        </b-col>
      </b-row>

      <!-- Group 2: First 4 from stopline -->
      <b-row
        class="mx-1"
        style="padding-left: 20px;"
      >
        <b-col
          v-for="(item, index) in stopline.slice(0, 4)"
          :key="'stopline' + index"
          lg="3"
          md="6"
          sm="12"
        >
          <b-link
            v-b-modal="'Live'"
            @click="$refs.RTSP.streamLive(stopline[index].RTSP_URL)"
          >
            <video
              :id="'stopline' + index"
              muted
              autoplay
              playsinline
              style="height: 140px; width: 70%; object-fit: cover; object-position: top center; margin: 0 auto; display: block;"
            />
          </b-link>
          <span style="display: block; margin: 0; text-align: center; font-size: 12px;">{{ item.Phase }}<br></span>
          <span style="display: block; margin: 0; text-align: center; font-size: 12px; margin-top: -18px;">{{ item.Camera_Desc }}</span>
        </b-col>
      </b-row>

      <!-- Group 3: Next 4 from count -->
      <b-row
        class="mx-1"
        style="padding-left: 20px;"
      >
        <b-col
          v-for="(item, index) in count.slice(4, 8)"
          :key="'count' + (index + 4)"
          lg="3"
          md="6"
          sm="12"
        >
          <b-link
            v-b-modal="'Live'"
            @click="$refs.RTSP.streamLive(count[index].RTSP_URL)"
          >
            <video
              :id="'count' + (index + 4)"
              muted
              autoplay
              playsinline
              style="height: 140px; width: 70%; object-fit: cover; margin: 0 auto; display: block;"
            />
          </b-link>
          <span style="display: block; margin: 0; text-align: center; font-size: 11px;">{{ item.Phase }}<br></span>
          <span style="display: block; margin: 0; text-align: center; font-size: 11px; margin-top: -18px;">จุดติดตั้ง: {{ item.Camera_Desc }}</span>
        </b-col>
      </b-row>

      <!-- Group 4: Next 4 from stopline -->
      <b-row
        class="mx-1"
        style="padding-left: 20px;"
      >
        <b-col
          v-for="(item, index) in stopline.slice(4, 8)"
          :key="'stopline' + (index + 4)"
          lg="3"
          md="6"
          sm="12"
        >
          <b-link
            v-b-modal="'Live'"
            @click="$refs.RTSP.streamLive(stopline[index].RTSP_URL)"
          >
            <video
              :id="'stopline' + (index + 4)"
              muted
              autoplay
              playsinline
              style="height: 140px; width: 70%; object-fit: cover; margin: 0 auto; display: block;"
            />
          </b-link>
          <span style="display: block; margin: 0; text-align: center; font-size: 11px;">{{ item.Phase }}<br></span>
          <span style="display: block; margin: 0; text-align: center; font-size: 11px; margin-top: -18px;">จุดติดตั้ง: {{ item.Camera_Desc }}</span>
        </b-col>
      </b-row>
    </div>
    <Live
      ref="RTSP"
    />
  </div>
</template>

<script>
/* eslint-disable global-require */
import Hls from 'hls.js'
import {
  BRow, BCol, BLink,
  // BImg, BCard,
} from 'bootstrap-vue'
import 'swiper/swiper-bundle.css'
import axios from '@axios'
import Live from './Live.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    // BCard,
    // BImg,
    Live,

  },
  data() {
    return {
      count: [],
      userData: JSON.parse(localStorage.getItem('userData')),
      itemsCount: [],
      stopline: [],
      check: '',
      countPhase: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.checkPhase()
    this.getCamTraffic()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.checkPhase()
      this.getCamTraffic()
    }, 300000)
  },
  methods: {
    checkPhase() {
      axios
      // 732 722 223
        .post('/checkPhaseTraffic', { wid: this.$route.query.wid })
        .then(response => {
          this.check = response.data[0].PhaseNo
          this.countPhase = response.data[0].CountPhase
          console.log(this.countPhase)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getCamTraffic() {
      axios
        .post('/getCamTrafficDetail', { wid: this.$route.query.wid })
        .then(response => {
          response.data.forEach(value => {
            if (value.Type === 'Count') {
              this.count.push({ RTSP_URL: value.RTSP_URL, Camera_Desc: value.Camera_Desc })
            }
            if (value.Type === 'StopLine') {
              this.stopline.push({ RTSP_URL: value.RTSP_URL, Camera_Desc: value.Camera_Desc })
            }
          })
          if (this.check < 4) {
            setTimeout(() => this.count.forEach(() => {
              this.for3()
            }), 500)
          } else {
            setTimeout(() => this.count.forEach(() => {
              this.for4()
            }), 500)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    for3() {
      setTimeout(() => this.count.slice(0, 3).forEach((value, i) => {
        this.stream(value.RTSP_URL, i)
      }), 500)
      setTimeout(() => this.stopline.slice(0, 3).forEach((value, i) => {
        this.stream1(value.RTSP_URL, i)
      }), 500)
      setTimeout(() => this.stopline.slice(2, 3).forEach((value, i) => {
        this.stream2(value.RTSP_URL, i)
      }), 500)
      setTimeout(() => this.count.slice(2, 3).forEach((value, i) => {
        this.stream3(value.RTSP_URL, i)
      }), 500)
    },
    stream(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#count${i}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
    stream1(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#stopline${i}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
    stream2(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#stopline${i + 2}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
    stream3(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#count${i + 2}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
    for4() {
      setTimeout(() => this.count.slice(0, 3).forEach((value, i) => {
        this.stream4(value.RTSP_URL, i)
      }), 500)
      setTimeout(() => this.stopline.slice(0, 3).forEach((value, i) => {
        this.stream5(value.RTSP_URL, i)
      }), 500)
      setTimeout(() => this.stopline.slice(2, 4).forEach((value, i) => {
        this.stream6(value.RTSP_URL, i)
      }), 500)
      setTimeout(() => this.count.slice(2, 4).forEach((value, i) => {
        this.stream7(value.RTSP_URL, i)
      }), 500)
    },
    stream4(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#count${i}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
    stream5(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#stopline${i}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
    stream6(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#stopline${i + 2}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
    stream7(value, i) {
      this.hls = new Hls({
        lowLatencyMode: true,
        autoreconnect: true,
      })
      const video = document.querySelector(`#count${i + 2}`)
      const videoSrc = value
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = videoSrc
      } else if (Hls.isSupported()) {
        this.hls.loadSource(videoSrc)
        this.hls.attachMedia(video)
        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play()
        })
      }
    },
  },
}
</script>

<style >
video {
  border-radius: 8px;
  height: 130px;
  width: 300px;
}

::-webkit-scrollbar {
  display: none;
}
/*.scrollable-container {
  overflow-y: auto;
  max-height: 90vh;
}*/

.video-grid .video-style {
  width: 90%; /* Ensures video fills the column width */
  aspect-ratio: 16/9; /* Keeps video aspect ratio */
}

.video-grid .text-style {
  color: white;
  margin-top: -7px;
  font-size: 0.9rem;
}
</style>
